const dummyCoordinates = [
    [
        -74.01260261073602,
        40.705024403133024
    ],
    [
        -74.01251188228036,
        40.7052995192401
    ],
    [
        -74.01233042536953,
        40.70565716848134
    ],
    [
        -74.0121126770759,
        40.7060423270548
    ],
    [
        -74.01200380292909,
        40.70628992781781
    ],
    [
        -74.01187678309113,
        40.70649626108485
    ],
    [
        -74.01164088910693,
        40.706482505553225
    ],
    [
        -74.01144128650442,
        40.70637246120117
    ],
    [
        -74.01125982959307,
        40.706303683389194
    ],
    [
        -74.01111466406451,
        40.70646875001955
    ],
    [
        -74.01080618731521,
        40.70675761563788
    ],
    [
        -74.0107517502418,
        40.70700521374232
    ],
    [
        -74.01071545885954,
        40.70714276784625
    ],
    [
        -74.01029810796396,
        40.70688141480477
    ],
    [
        -74.01011665105261,
        40.706743860160174
    ],
    [
        -74.00986261137724,
        40.70659254972347
    ],
    [
        -74.00966300877475,
        40.70652377213878
    ],
    [
        -74.00955413462793,
        40.70639997230623
    ],
    [
        -74.00968115446588,
        40.7060423270548
    ],
    [
        -74.00980817430383,
        40.70576721401534
    ],
    [
        -74.00991704845066,
        40.70558838993068
    ],
    [
        -74.00995333983239,
        40.705423321118275
    ],
    [
        -74.00995333983239,
        40.705230740320076
    ],
    [
        -74.01013479674373,
        40.705161961329
    ],
    [
        -74.01064287609498,
        40.705161961329
    ],
    [
        -74.0109513528443,
        40.70507942644551
    ],
    [
        -74.01135055804876,
        40.70507942644551
    ],
    [
        -74.01149572357784,
        40.70503815896501
    ],
    [
        -74.01171347187145,
        40.70499689145967
    ],
    [
        -74.01207638569363,
        40.705024403133024
    ],
    [
        -74.01240300813409,
        40.705024403133024
    ],
    [
        -74.01263890211828,
        40.70503815896501
    ]
]


class FakeNavigator {
    getCurrentPosition(success) {
        // console.log('invoked getCurrentPosition', success)
    }

    watchPosition(success) {
        let i = 0;

        setInterval(() => {
            const [longitude, latitude] = dummyCoordinates[i]

            success({
                coords: {
                    longitude,
                    latitude
                },
                timestamp: 12345
            })

            if (i < dummyCoordinates.length - 1) {
                i += 1
            } else {
                i = 0
            }
        }, 1000)
    }
}

export default FakeNavigator